import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Media from 'react-media';
import { Dialog } from '@material-ui/core';
import GlobalTheme, { breakpointValues } from '../../styled/GlobalTheme';
import GliderComponent from './GliderCarousel';
import { NextArrowIcon, BeforeArrowIcon } from '../../assets/icons/iconRepository';

const Container = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
`;
const CustomDialog = styled(Dialog)`
&&{
    .MuiPaper-root{
      width: ${({ itemWidth }) => (itemWidth)}px;
      max-width: 873px;
      height: 524px;
    }
  }
`;

const CustomGliderCarousel = styled(GliderComponent)`
  && {
    width: 100%;
    height: 100%;
    .glider {
      pointer-events: none;
      @media (max-height: 425px) {
        height: 100%;
      }
    }
    button {
      pointer-events: auto;
    }
    .glider-contain {
      height: 100%;
    }
    .glider-next {
      margin-right: -22px;
      top: calc(50% - 20px);
      right: 51px!important;
      background-image: url(${NextArrowIcon});
      background-color: transparent;
      ${GlobalTheme.breakpoints.down('sm')}{
        margin-right: -40px;
      }
    }
    .glider-prev {
      margin-left: -22px;
      top: calc(50% - 20px);
      left: 51px!important;
      background-color: transparent;
      background-image: url(${BeforeArrowIcon});
      ${GlobalTheme.breakpoints.down('sm')}{
        margin-left: -40px;
      }
    }
    .glider-track {
      height: 532px;
      @media (max-height: 425px) {
        height: 100%;
      }
    }
    .glider-dots {
      position: absolute;
      bottom: 21px;
      margin-left: auto;
      margin-right: auto;
      left: 0;
      right: 0;
      text-align: center;
      width: fit-content;
      .glider-dot {
        background: ${({ theme }) => (theme.colors.white)};
        opacity: 0.2;
      }
      .active {
        background: ${({ theme }) => (theme.colors.white)};
        opacity: 1;
      }
    }
  }
`;

const CarouselModal = ({ sliders, open, onBackdropClick }) => (
  <Media queries={{
    sm: `(max-width: ${breakpointValues.md - 1}px)`,
    md: `(max-width: ${breakpointValues.lg - 1}px)`,
    lg: `(min-width: ${breakpointValues.lg}px)`,
  }}
  >
    {(matches) => {
      let itemWidth = 870;
      if (matches.md) itemWidth = 690;
      if (matches.sm) itemWidth = 310;
      return (
        <CustomDialog
          itemWidth={itemWidth}
          open={open}
          onBackdropClick={onBackdropClick}
        >
          <Container>
            <CustomGliderCarousel
              hasArrows
              hasDots
              settings={{
                itemWidth,
                exactWidth: true,
                slidesToShow: 1,
                slidesToScroll: 1,
              }}
            >
              {sliders.map((slider) => (
                <>
                  {slider}
                </>
              ))}
            </CustomGliderCarousel>
          </Container>
        </CustomDialog>
      );
    }}
  </Media>
);

CarouselModal.propTypes = {
  sliders: PropTypes.instanceOf(Array).isRequired,
  open: PropTypes.bool.isRequired,
  onBackdropClick: PropTypes.func,
};

CarouselModal.defaultProps = {
  onBackdropClick: () => {},
};

export default CarouselModal;
